import React, { useEffect } from "react";
import Swal from "sweetalert2";
import {  useNavigate } from "react-router-dom";

const Cancel = () => {
    const navigate = useNavigate(); // Get the navigate function

    useEffect(() => {
      // Show the SweetAlert2 alert
      Swal.fire({
        title: 'Payment Cancelled!',
        text: 'You will be redirected shortly.',
        icon: 'error',
        timer: 3000, // Time in milliseconds (3000ms = 3 seconds)
        timerProgressBar: true,
        willClose: () => {
          // This function will be called when the alert is closed
          navigate('/checkout'); // Replace '/new-route' with your desired route
        }
      });
    }, [navigate]);


    return null;
};

export default Cancel;
